import { Component } from 'react'
import {ApiQuery, JSONFetcher, gaEvent} from 'shared'

const DefaultFilter = {
  state: 'activated',
  min_activity_threshold_reached: true,
  hidden_from_platform: false
}

const DefaultOrder = {
  category_boost: 'desc',
  score: 'desc',
  completed: 'asc',
  rank: 'desc',
  last_donation_at: 'desc'
}

export const apiV4Search = (WrappedComponent) => {
  return class extends Component {
    constructor(props) {
      super(props)
      this.state = {
        page: 1,
        perPage: 27,
        projects: [],
        totalEntries: 0,
        totalPages: 0,
        isLoading: true,
      }
    }

    componentDidMount() {
      this.loadProjectPage(1)
    }

    componentDidUpdate(prevProps, _prevState) {
      const queryChanged = prevProps.categoryId != this.props.categoryId ||
        prevProps.bounds != this.props.bounds ||
        prevProps.searchQuery != this.props.searchQuery

      if (queryChanged) {
        this.setState({projects: []})
        this.loadProjectPage(1)
      }
    }

    loadProjectPage = (page) => {
      this.state.abortController && this.state.abortController.abort()
      const abortController = window['AbortController'] && new AbortController()

      this.setState({abortController, isLoading: true})

      let query = new ApiQuery(this.props.apiBaseUrl)

      query.search(this.props.searchQuery).addBounds(this.props.bounds)
        .page(page).per(this.state.perPage)
        .filter(this.props.searchFilter || DefaultFilter)
        .order(DefaultOrder)
        .category(this.props.categoryId)

      JSONFetcher.load({url: query.toUrl(), success: this.onProjectsLoaded, signal: abortController && abortController.signal})
    }

    onProjectsLoaded = (json) => {
      const newProjects = this.state.projects.concat(json.data)
      this.setState({
        projects:            newProjects,
        totalEntries:        json.total_entries,
        totalPages:          json.total_pages,
        page:                json.current_page,
        isLoading:           false,
      })
    }

    loadNextPage = (event) => {
      event.preventDefault()
      gaEvent('engagement', 'click show_more_projects_link')
      this.loadProjectPage(this.state.page + 1)
    }

    render() {
      return <WrappedComponent
        {...this.state}
        {...this.props}
        loadNextPage={this.state.page < this.state.totalPages ? this.loadNextPage : null}
      />
    }
  };
}
